<ion-header>
  <ion-toolbar color="secondary">
    <ion-buttons aria-hidden="true" slot="start">
      <ion-button>
        <ion-icon [src]="'information' | srcAssets" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title [attr.aria-hidden]="!title" [attr.tabindex]="1" class="title-2">{{ (title || '') | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button [attr.aria-label]="'btn_modal_close'| ariaLabel | translate" [appAriaButton]="'btn_modal_close' | ariaLabel | translate" (click)="close()">
        <ion-icon aria-hidden="true" name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card class="ion-margin">
    <ion-card-content>
      <div class="ion-margin-bottom">
        <p tabindex="3" [attr.aria-hidden]="!description" [innerHTML]="(description || '') | translate"></p>
      </div>

      <app-bullet-list *ngIf="!!bullets" [bullets]="bullets"></app-bullet-list>
    </ion-card-content>
  </ion-card>
</ion-content>